
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.76 7.265l1.91-3.303h2.505l-3.07 4.945L9.276 14H6.791l-2.004-3.433L2.792 14H.288L3.46 8.907.4 3.962h2.486L4.76 7.265zM14.455 8.838l2.126-4.38h1.777l-3.097 5.84V13.7h-1.613v-3.402l-3.104-5.84h1.784l2.127 4.38z","fill-opacity":".7"}}),_c('path',{attrs:{"d":"M14.455 8.838l-.27.13.27.557.27-.556-.27-.131zm2.126-4.38v-.3h-.188l-.082.169.27.131zm1.777 0l.265.14.234-.44h-.499v.3zm-3.097 5.84l-.265-.14-.035.065v.075h.3zm0 3.402v.3h.3v-.3h-.3zm-1.613 0h-.3v.3h.3v-.3zm0-3.402h.3v-.075l-.035-.066-.265.14zm-3.104-5.84v-.3h-.499l.235.44.264-.14zm1.784 0l.27-.131-.082-.169h-.188v.3zm2.397 4.51L16.85 4.59l-.54-.262-2.126 4.38.54.262zm1.856-4.21h1.777v-.6h-1.777v.6zm1.512-.44l-3.097 5.84.53.28 3.097-5.84-.53-.28zm-3.132 5.98V13.7h.6v-3.402h-.6zm.3 3.102h-1.613v.6h1.613v-.6zm-1.313.3v-3.402h-.6V13.7h.6zm-.035-3.543l-3.104-5.84-.53.282 3.104 5.84.53-.282zm-3.369-5.399h1.784v-.6h-1.784v.6zm1.514-.169l2.127 4.38.54-.262-2.127-4.38-.54.262z","fill-opacity":".7"}})])
          )
        }
      }
    